import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import profile2 from "../../../Assets/imageupload.png";
import Button from "@mui/material/Button";
import {
  startFetchingSupportDocuments,
  startEditingSupportDocument,
} from "../../../Redux/Slice";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import ImageCropper from "../ReactcropOverall/Imagecrop";
import BackImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";
import { PresentUrl } from "../../../text/apidata";
import { store } from "../../../Redux/Store";
import axios from "axios";
import pdfIcon from "../../../Assets/pdf.png";
import excelIcon from "../../../Assets/excelIcon.png";

const SupportDocumentFile = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive,
  );
  const dispatch = useDispatch();
  const state = useSelector((state) => state);

  const [images, setImages] = useState(Array(5).fill(null));
  const [imgsrc, setImgsrc] = useState("");
  const [crop, setCrop] = useState();
  const [CroppImageView, setCroppImageView] = useState(false);
  const imgRef = useRef(null);
  const [croppingIndex, setCroppingIndex] = useState(null);
  const navigate = useNavigate();
  const [UploadImages, setUploadImages] = useState();
  const fileInputRef = useRef();
  ///---present---url
  const [PresentUrls, setPresentUrls] = useState([]);
  const [presenturlInUrl, seturlandfile] = useState({
    file: "",
    url: "",
  });
  const ImageRender = useRef();
  const [PresentUrlBool, setPresentUrlBool] = useState(false);

  useEffect(() => {
    const payload = {
      EditID:
        state.BasicFormCreated.user_ID == ""
          ? state.EmployeeProfile.EmployeeProfileList.id
          : state.BasicFormCreated.user_ID,
      Reload: 2,
    };
    dispatch(startFetchingSupportDocuments(payload));
  }, [state.EmployeeProfile.EmployeeProfileList]);
  const onImageLoaded = (image) => {
    // imgRef = image;
    imgRef.current = image;
  };

  // useEffect(() => {

  //   if (
  //       state.SupportDocumentFetch.SupportDocuments != null &&
  //     state.SupportDocumentFetch.SupportDocuments != undefined &&
  //     state.SupportDocumentFetch.SupportDocuments.support_documents != null &&
  //     state.SupportDocumentFetch.SupportDocuments.support_documents != undefined
  //   ) {
  //     setImages()
  //     const fetchedImages =
  //       state.SupportDocumentFetch.SupportDocuments.support_documents
  //         .filter((doc) => doc.media_url !== null) // Filter out null media_url
  //         .map((doc) => ({
  //           id: doc.id,
  //           media_url: doc.media_url,
  //         }));
  //     const updatedImages = [
  //       ...fetchedImages,
  //       ...Array(5 - fetchedImages.length).fill(null),
  //     ];
  //     setImages(updatedImages);
  //   } else {
  //     setImages(Array(5).fill(null));
  //   }
  // }, [
  //   state.SupportDocumentFetch.SupportDocuments,
  //   state.SupportDocumentEdit.EditedSupportDocument,
  //   state.EmployeeProfile.EmployeeProfileList,
  //   state.SupportDocumentFetch ,
  //   state.SupportDocumentFetch.SupportDocuments.support_documents,
  //   PresentUrlBool  ]);

  useEffect(() => {
    // Function to fetch and update images
    const updateImages = () => {
      const supportDocuments = state.SupportDocumentFetch.SupportDocuments;

      if (supportDocuments && supportDocuments.support_documents) {
        const fetchedImages = supportDocuments.support_documents
          .filter((doc) => doc.media_url !== null) // Filter out null media_url
          .map((doc) => ({
            id: doc.id,
            media_url: doc.media_url,
          }));

        const updatedImages = [
          ...fetchedImages,
          ...Array(5 - fetchedImages.length).fill(null),
        ];
        setImages(updatedImages);
      } else {
        setImages(Array(5).fill(null));
      }
    };

    // Initial data fetch
    updateImages();

    // Set up an interval to update every 15 seconds
    const intervalId = setInterval(updateImages, 15000);

    // Clear the interval on component unmount
    return () => clearInterval(intervalId);
  }, [
    state.SupportDocumentFetch.SupportDocuments,
    state.SupportDocumentEdit.EditedSupportDocument,
    state.EmployeeProfile.EmployeeProfileList,
    PresentUrlBool,
  ]);

  const setCompletedCrop = async (c) => {
    const croppedImageUrl = await getCroppedImg(
      imgRef.current,
      c,
      "newfile.jpeg",
    );
  };

  const selectedImage = (e) => {
    console.log(e.target.files[0]);
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setImgsrc(reader.result));
      reader.readAsDataURL(e.target.files[0]);
      console.log(imgsrc, "imgsrc");
    }
  };
  const uploadFileDirectly = async (file) => {
    const formData = new FormData();
    formData.append("file_1", file);
    formData.append("operation_type", "add");

    const generateRandomNumber = () => Math.floor(Math.random() * 100000);

    const formattedFilename = `onboarding/form_support_doc/form_support_doc${generateRandomNumber()}.${file.name
      .split(".")
      .pop()}`;

    const Presentdata = {
      multiple_files: [
        {
          filename: formattedFilename,
          file_type: file.type,
        },
      ],
    };

    try {
      const response = await axios({
        url: PresentUrl,
        method: "post",
        data: Presentdata,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      });

      const uploadedUrl = response.data.data[0];

      await fetch(uploadedUrl, {
        method: "PUT",
        headers: {
          "Content-Type": file.type,
          "x-amz-acl": "public-read",
        },
        body: file,
      });

      const payload = {
        formData,
        removeformdata: {
          file: uploadedUrl.split("?")[0],
          operation_type: "add",
        },
        EditID:
          state.BasicFormCreated.user_ID ||
          state.EmployeeProfile.EmployeeProfileList.id,
      };

      dispatch(startEditingSupportDocument(payload));

      setPresentUrlBool((prev) => !prev);
      setImages(Array(5).fill(null));
    } catch (error) {
      console.error("Upload error:", error);
    }
  };
  // const handleFileChange = (e, index) => {
  //   const file = e.target.files[0];
  //   const allowedTypes = ["image/jpeg", "image/png", "image/svg+xml"];
  //   const maxSize = 10 * 1024 * 1024; // 3MB in bytes
  //   const MIN_DIMENSION = 150;
  //     setCroppingIndex(index);
  //     setCroppImageView(true);
  //     setUploadImages(e)
  //   // if (file) {
  //   //   setImgsrc(URL.createObjectURL(file));

  //   //   if (allowedTypes.includes(file.type)) {
  //   //     if (file.size > maxSize) {
  //   //       setCroppImageView(false);
  //   //       toast.error("File size exceeds 10MB. Please upload a smaller image.");
  //   //     } else {
  //   //       setImgsrc(URL.createObjectURL(file)); // Set the image source for cropping
  //   //       selectedImage(e);
  //   //     }
  //   //   } else {
  //   //     setCroppImageView(false);
  //   //     toast.error("Please upload an image file (jpg, jpeg, png, svg).");
  //   //   }
  //   // }
  //   if (file && allowedTypes.includes(file.type)) {
  //     if (file.size > maxSize) {
  //       setCroppImageView(false);
  //       toast.error("File size exceeds 10MB. Please upload a smaller image.");
  //     } else {
  //       const reader = new FileReader();
  //       reader.addEventListener("load", () => {
  //         const imageElement = new Image();
  //         const imageUrl = reader.result?.toString() || "";
  //         imageElement.src = imageUrl;

  //         imageElement.addEventListener("load", (imgEvent) => {
  //           const { naturalWidth, naturalHeight } = imgEvent.currentTarget;

  //           if (naturalWidth < MIN_DIMENSION || naturalHeight < MIN_DIMENSION) {
  //             toast.error("Image must be at least 150 x 150 pixels.");
  //             setCroppImageView(false);
  //             return;
  //           }
  //             selectedImage(e); // Continue processing the image
  //         });
  //       });
  //       reader.readAsDataURL(file); // Read the file as a data URL
  //     }
  //   } else {
  //     setCroppImageView(false);
  //     toast.error("Please upload an image file (jpg, jpeg, png, svg).");
  //     // e.target.value = ""; // Clear the file input
  //   }

  // };
  const allowedTypes = [
    "image/jpeg",
    "image/png",
    "image/svg+xml",
    "application/pdf",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ];

  const handleFileChange = (e, index) => {
    const file = e.target.files[0];
    const maxSize = 10 * 1024 * 1024;

    if (!file) return;

    const isImage = file.type.startsWith("image/");
    const isDoc =
      file.type === "application/pdf" ||
      file.type === "application/vnd.ms-excel" ||
      file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

    if (!allowedTypes.includes(file.type)) {
      toast.error("Unsupported file type.");
      return;
    }

    if (file.size > maxSize) {
      toast.error("File size exceeds 10MB.");
      return;
    }

    setCroppingIndex(index);

    // ✅ IMAGE FLOW (with crop)
    if (isImage) {
      const MIN_DIMENSION = 150;

      const reader = new FileReader();
      reader.onload = () => {
        const img = new Image();
        img.src = reader.result;

        img.onload = () => {
          if (
            img.naturalWidth < MIN_DIMENSION ||
            img.naturalHeight < MIN_DIMENSION
          ) {
            toast.error("Image must be at least 150x150");
            return;
          }

          setUploadImages(e);
          setCroppImageView(true); // open cropper
        };
      };

      reader.readAsDataURL(file);
    }

    // ✅ PDF / EXCEL FLOW (no crop → direct upload)
    else if (isDoc) {
      uploadFileDirectly(file);
    }
  };
  function getCroppedImg(imageRef, crop, fileName) {
    const canvas = document.createElement("canvas");
    const scaleX = imageRef.current.naturalWidth / imageRef.current.width;
    const scaleY = imageRef.current.naturalHeight / imageRef.current.height;
    canvas.width = crop.width * scaleX;
    canvas.height = crop.height * scaleY;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      imageRef.current,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY,
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          //reject(new Error('Canvas is empty'));
          console.error("Canvas is empty");
          return;
        }

        const croppedFile = new File([blob], "croppedimg.jpg", {
          type: "image/jpeg",
        });

        if (croppedFile) {
          setTimeout(() => {
            setCroppImageView(false);
          }, 0);
        }

        const croppedImageUrl = URL.createObjectURL(croppedFile);

        const formData = new FormData();
        formData.append("file_1", croppedFile);
        formData.append("operation_type", "add");
        const generateRandomNumber = () => {
          return Math.floor(Math.random() * 100000);
        };

        const createPresentData = (croppedFile) => {
          const randomNumber = generateRandomNumber();
          const formattedFilename = `onboarding/form_support_doc/form_support_doc${randomNumber}.${croppedFile.type.split("/")[1]}`; // Use the file's extension
          const Presentdata = {
            multiple_files: [
              {
                filename: formattedFilename,
                file_type: croppedFile.type,
              },
            ],
          };

          return Presentdata;
        };

        let ULS; ///-- get the url
        let wholeobject; // get the url , type , file
        const Presentdata = createPresentData(croppedFile);

        if (croppedFile != undefined) {
          axios({
            url: PresentUrl,
            method: "post",
            data: Presentdata,
            headers: {
              Authorization:
                "Bearer " + store.getState().users.UserData.session.token,
            },
          })
            .then((response) => {
              console.log("Files uploaded successfully:", response.data);
              const uploadedFiles = response.data.data;
              const newUrls = uploadedFiles.map((file) => ({
                url: file,
                type: croppedFile.type,
                putfiles: croppedFile,
              }));
              wholeobject = uploadedFiles.map((file) => ({
                url: file,
                type: croppedFile.type,
                putfiles: croppedFile,
              }));
              // Update PresentUrls state
              setPresentUrls((prevUrls) => [...prevUrls, ...newUrls]);
              seturlandfile({
                url: String(response.data.data).split("?")[0],
              });
              ULS = String(response.data.data).split("?")[0];

              try {
                const responsePut = fetch(response.data.data[0], {
                  method: "PUT",
                  headers: {
                    "Content-Type": croppedFile.type,
                    "x-amz-acl": "public-read",
                  },
                  body: croppedFile,
                });
                console.log(croppedFile, "responsdsaePut");

                const payload = {
                  formData,
                  removeformdata: {
                    file: String(response.data.data).split("?")[0],
                    operation_type: "add",
                  },
                  EditID:
                    state.BasicFormCreated.user_ID ||
                    state.EmployeeProfile.EmployeeProfileList.id,
                };

                dispatch(startEditingSupportDocument(payload));

                setTimeout(() => {
                  setPresentUrlBool(!PresentUrlBool);
                  setImages(Array(5).fill(null));
                }, 600);
              } catch (error) {
                console.error("Error uploading files:", error);
              }
            })
            .catch((error) => {
              console.error("Error uploading files:", error);
            });
        }

        blob.name = fileName;
        let fileUrl = window.URL.createObjectURL(blob);
        console.log(fileUrl);
        resolve(fileUrl);
      }, "image/jpeg");
    });
  }
  const removeImage = (index, ids) => {
    // setImages(images.map((img, i) => (i === index ? null : img)));
    const updatedImages = images.map((img, i) => (i === index ? null : img));
    setImages(updatedImages);

    const removeformdata = {
      support_documents: ids,
      operation_type: "remove",
    };
    const payload = {
      removeformdata: removeformdata,
      EditID:
        state.BasicFormCreated.user_ID === ""
          ? state.EmployeeProfile.EmployeeProfileList.id
          : state.BasicFormCreated.user_ID,
    };
    setTimeout(() => {
      setPresentUrlBool(!PresentUrlBool);
    }, 600);
    dispatch(startEditingSupportDocument(payload));
  };
  const updateAvatar = (imgSrc) => {
    // fileInputRef.current.value = imgSrc;
  };
  const getFilePreview = (fileData) => {
    if (!fileData) return null;

    const value = fileData.toLowerCase();
    console.log(value, "kalsdkaksldkla", value.endsWith(".pdf"));

    if (value.endsWith(".pdf")) return pdfIcon;
    if (value.endsWith(".xls") || value.endsWith(".xlsx")) return excelIcon;

    return fileData; // image base64
  };

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>Upload Documents </h3>
          </div>
        </div>
        <div
          className="row Filters ButtonPrevious"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "30",

            marginLeft: "0px",
            marginRight: "0px",
            top: "-26px",
          }}
        >
          <div className="col">
            <button
              className="btn BackImga"
              onClick={(e) => {
                navigate("/employeeprofile");
              }}
            >
              <img className="PreviousPages" src={BackImage} />
              <span></span>
            </button>
          </div>
        </div>
        <div className="image-uploader">
          <div className="image-preview-grid">
            {images.map((image, index) => (
              <div
                key={index}
                className={`image-preview image-preview1 ${
                  !image ? "objects" : ""
                }`}
                ref={ImageRender}
              >
                {image &&
                (image.media_url !== "" || image.media_url !== null) ? (
                  <>
                    <span>
                      <img
                        src={getFilePreview(image.media_url)}
                        onClick={(e) => {
                          if (state.NumberCounts.Editable == 1) {
                            window.open(image.media_url);
                          }
                        }}
                      />
                    </span>
                    <button
                      onClick={() => removeImage(index, image.id)}
                      className="remove-button"
                      disabled={
                        state.NumberCounts.Editable == 1 &&
                        state.ClientBranchIDs.SUBROLE != 3
                          ? true
                          : false
                      }
                    >
                      X
                    </button>
                    <p className="Attachments">Attachment {index + 1}</p>
                  </>
                ) : (
                  <>
                    <label className="file-placeholder">
                      <input
                        type="file"
                        hidden
                        accept="image/png,image/jpeg,image/svg+xml,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        ref={fileInputRef}
                        onChange={(e) => handleFileChange(e, index)}
                        disabled={
                          state.NumberCounts.Editable == 1 &&
                          state.ClientBranchIDs.SUBROLE != 3
                            ? true
                            : false
                        }
                        readOnly={
                          state.NumberCounts.Editable == 1 &&
                          state.ClientBranchIDs.SUBROLE != 3 &&
                          state.EmployeeProfile.EmployeeProfileList != ""
                            ? true
                            : false
                        }
                      />
                      <img src={profile2} alt="placeholder" />
                    </label>
                    <p className="Attachments" style={{ marginTop: "12px" }}>
                      Attachment {index + 1}
                    </p>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {CroppImageView && (
        <ImageCropper
          updateAvatar={updateAvatar}
          selectedImage={UploadImages}
          getCroppedImg={getCroppedImg}
          closeModal={() => setCroppImageView(false)}
        />
      )}
    </>
  );
};

export default SupportDocumentFile;
